const steps = [
  {
    num: "1",
    title: "Start Your Order Online",
    description:
      "Go to fastpassportcenter.com and select Passport Renewal. Tell us your travel date. Our system guides you through exactly what you need — no guesswork, no missed documents.",
  },
  {
    num: "2",
    title: "Expert Document Review",
    description:
      "Before your application goes anywhere, our passport specialists review every document for errors. Wrong photo specs, missing signatures, incorrect dates — we catch them all before submission. This step alone prevents the weeks-long delays that DIY renewals often experience.",
  },
  {
    num: "3",
    title: "Hand-Courier Submission",
    description:
      "Mail us your signed DS-82, current passport, photo, and any name change documents using our prepaid overnight label. Our registered couriers hand-deliver your application to the U.S. passport agency using reserved daily submission slots the next business day.",
  },
  {
    num: "4",
    title: "Overnight Return",
    description:
      "Your renewed passport ships back to you via overnight FedEx the moment the agency releases it. Track everything through your personal dashboard. Your old passport is returned separately with a cancellation stamp.",
  },
];

export default function HowItWorksSection() {
  return (
    <section className="py-16 md:py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-[#1B4D3E] text-center mb-12">
          How Fast Passport Renewal Works — 4 Steps
        </h2>

        <div className="relative">
          <div className="absolute left-[23px] top-8 bottom-8 w-0.5 bg-green-200 hidden md:block"></div>

          <div className="space-y-10">
            {steps.map((step, i) => (
              <div key={i} className="flex gap-6 items-start">
                <div className="flex-shrink-0 w-12 h-12 rounded-full bg-[#1B4D3E] flex items-center justify-center text-white font-bold text-lg relative z-10">
                  {step.num}
                </div>
                <div className="flex-1 pt-1">
                  <h3 className="text-lg md:text-xl font-bold text-[#1B4D3E] mb-2">{step.title}</h3>
                  <p className="text-gray-600 leading-relaxed">{step.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="text-center mt-12">
          <a
            href="https://fastpassportcenter.com/checkout/?passport=passport-renewal"
            className="whitespace-nowrap inline-flex items-center gap-2 px-7 py-3.5 bg-[#C8A951] hover:bg-[#b8942e] text-[#1B4D3E] font-bold text-base rounded-md transition-colors cursor-pointer"
          >
            <i className="ri-rocket-line text-lg"></i>
            Start My Fast Renewal
          </a>
        </div>
      </div>
    </section>
  );
}